"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Format school data to select option object
 * @param school - School data information
 */
exports.formatSchool = (school) => ({
    label: `${school.name} - ${school.town} (${school.departmentCode})`,
    value: school.schoolId
});
//# sourceMappingURL=school.services.js.map